var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"invoice"}},[_c('div',{staticClass:"main-actions"},[_c('button',{staticClass:"floater",on:{"click":function($event){return _vm.printInvoice()}}},[_c('i',{staticClass:"far fa-print"})])]),_c('div',{staticClass:"invoice-selected"},[_c('invoice-template',{attrs:{"invoice":_vm.invoice}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }